import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';

import { TasksMenu } from './Menus';

const styles = theme => ({
  root: {

  },
  button: {
    backgroundColor: amber[500],
    color: "#fff",
  },
});

//TODO: move the task button into the task menu component
//and turn this into a factory
class ActionButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    }
  }

  handleClick = event => {
      this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, project, type, handleAdd } = this.props;
    const { anchorEl } = this.state;

    return(
      <div>
        {type === "tasks" &&
          <div>
            <Button
              className={classes.button}
              variant="fab"
              aria-label="add"
              onClick={(event) => this.setState({ anchorEl: event.currentTarget })}
              >
              <AddIcon />
            </Button>
            <TasksMenu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => this.setState({ anchorEl: null })}
              handleClick={(action) => {
                this.setState({anchorEl: null})
                handleAdd(action);
              }}
            />
          </div>
        }
        {type === "notes" &&
          <Button
            className={classes.button}
            variant="fab"
            aria-label="add"
            onClick={() => handleAdd({
              note: {
                projectId: project.id,
                createdDate: (new Date()).getTime(),
              }
            })}
            >
            <AddIcon />
          </Button>
        }
        {type === "files" &&
          <Button
            className={classes.button}
            variant="fab"
            aria-label="add"
            onClick={() => handleAdd({
              file: {
                projectId: project.id,
                createdDate: (new Date()).getTime(),
                title: "",
                category: "file",
              }
            })}
            >
            <AddIcon />
          </Button>
        }
        {type === "photos" &&
          <Button
            className={classes.button}
            variant="fab"
            aria-label="add"
            onClick={() => handleAdd({
              photo: {
                projectId: project.id,
                createdDate: (new Date()).getTime(),
                title: "",
                category: "photo",
              }
            })}
            >
            <AddIcon />
          </Button>
        }
        {type === "invoices" &&
          <Button
            className={classes.button}
            variant="fab"
            aria-label="add"
            onClick={() => handleAdd({
              invoice: {
                projectId: project.id,
                clientId: project.clientId,
              }
            })}
            >
            <AddIcon />
          </Button>
        }
        {type === "timecards" &&
          <Button
            className={classes.button}
            variant="fab"
            aria-label="add"
            onClick={() => handleAdd({
              timecard: {
                projectId: project.id,
                clientId: project.clientId,
              }
            })}
            >
            <AddIcon />
          </Button>
        }
        {type === "receipts" &&
          <Button
            className={classes.button}
            variant="fab"
            aria-label="add"
            onClick={() => handleAdd({
              receipt: {
                projectId: project.id,
                clientId: project.clientId,
              }
            })}
            >
            <AddIcon />
          </Button>
        }
      </div>
    );
  }
}

export default withStyles(styles)(ActionButton);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Actions/ActionButton.jsx